import { Routes } from "@angular/router";

export const AGENTE_ROUTES: Routes = [
  { path: '', redirectTo: 'agente', pathMatch: 'full' },
  { path: 'agente', loadChildren: './pages/agente/agente.module#AgenteModule' }
];